module.exports = {
    env: process.env.NODE_ENV || 'development',
    baseUrl: process.env.STATIC_BASE_URL || '//static.technogramsolutions.com',
    metaTitle: process.env.TITLE || 'Technogram',
    favicon: process.env.FAVICON || 'favicon'
};
